<div class="column spacing-24">
	<div class="content-container">
		<div class="content-container-header">
			<h3><b i18n="@@assignRole-roles">Roles</b></h3>
			<p i18n="@@assignRole-actionsMessage">Define what actions this user can take in relation to your company</p>
		</div>

		<mat-divider></mat-divider>

		<div class="content-container-body column spacing-24">
			<div class="row spacing-24">
				@if (showCompanyDropdown) {
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
						<mat-label i18n="@@assingRole-company">Company</mat-label>
						<mat-select
							disableOptionCentering
							[ngModel]="selectedCompany"
							(ngModelChange)="onCompanySelected($event)"
							data-automation-id="company-option-picker"
							required
						>
							@for (option of companyOptions; track option; let idx = $index) {
								<mat-option [value]="option.value" [attr.data-automation-id]="'company-option-' + idx">
									{{ option.label }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				}

				<div class="column"></div>
			</div>
			<div class="row spacing-24">
				<app-loading-indicator [keys]="[apiLoadingKeys.getCompanyRolesByCompanyId]" diameter="30" class="column">
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
						<mat-label i18n="@@assignRole-role">Role</mat-label>
						<mat-select
							disableOptionCentering
							[ngModel]="selectedRole"
							(ngModelChange)="onRoleDropdownSelected($event)"
							data-automation-id="role-option-picker"
							required
						>
							@for (option of roleOptions; track option; let idx = $index) {
								<mat-option [value]="option.value" [attr.data-automation-id]="'role-option-' + idx">
									{{ option.label }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</app-loading-indicator>

				<div class="column"></div>
			</div>
			<div class="row spacing-24">
				@if (addCustomRoleSelected) {
					<mat-form-field
						subscriptSizing="dynamic"
						appearance="outline"
						class="column half-width"
						style="margin-top: 1rem"
					>
						<mat-label i18n="@@assignRole-customRoleName">Custom Role Name</mat-label>
						<input
							matInput
							[ngModel]="customRoleName"
							(ngModelChange)="onCustomRoleNameChange($event)"
							data-automation-id="custom-role-input"
							required
						/>
					</mat-form-field>
				}
			</div>
		</div>
	</div>

	<app-loading-indicator
		[keys]="[apiLoadingKeys.getSystemCapabilitiesByRoleId, apiLoadingKeys.getRoleCapabilities]"
		diameter="30"
		boxMinHeight="50px"
	>
		@if (systemCapabilityItems.length > 0) {
			<app-system-capability-table
				[roleName]="roleName"
				[companyId]="selectedCompany?.id ?? ''"
				[companyType]="companyType"
				[systemCapabilityItems]="systemCapabilityItems"
				[mode]="systemCapabilityTableMode"
				(systemCapabilitiesToggleEvents)="onCapabilityToggle($event)"
				style="margin-bottom: 75px"
			></app-system-capability-table>
		}
	</app-loading-indicator>
</div>
